import { buildAndroidChromeIntentUrl, iosOpenInBrowserInstructions, type OsKind } from "../env";

type Props = {
  imageUrl: string;
  os: OsKind;
  onClose: () => void;
};

/**
 * Bước 3 của chuỗi fallback tải ảnh (docs/73-facebook-integration.md §2.3) — mặc định an toàn
 * nhất trong in-app browser: ảnh chiếm toàn màn hình, người dùng tự "Chạm giữ → Lưu ảnh"
 * (context menu ảnh cấp hệ điều hành, không phụ thuộc JS API của trang nên vượt qua được phần
 * lớn hạn chế của WebView).
 */
export default function FullscreenImageGuide({ imageUrl, os, onClose }: Props) {
  return (
    <div className="fullsize-overlay" role="dialog" aria-modal="true" aria-label="Lưu ảnh QR">
      <button type="button" className="fullsize-close" onClick={onClose} aria-label="Đóng">
        ✕
      </button>

      <img src={imageUrl} alt="Mã QR của bạn — chạm giữ để lưu" className="fullsize-image" />

      <div className="fullsize-guide">
        <p className="fullsize-guide-title">Chạm giữ vào ảnh phía trên rồi chọn "Lưu ảnh"</p>
        <p className="hint-text small">
          Trình duyệt này có thể tải ảnh không mượt, nên mình hiện ảnh to sẵn cho bạn lưu thủ công.
        </p>

        {os === "android" ? (
          <button
            type="button"
            className="btn btn-secondary btn-block"
            onClick={() => {
              try {
                window.location.href = buildAndroidChromeIntentUrl(window.location.href);
              } catch {
                // Thất bại im lặng — đây là lối thoát phụ, không phải luồng chính.
              }
            }}
          >
            Mở bằng Chrome
          </button>
        ) : (
          <p className="hint-text small">{iosOpenInBrowserInstructions()}</p>
        )}
      </div>
    </div>
  );
}
